
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { formatDate } from "../../utils";
import form from "../mixins/form";
import formText from "../mixins/form-text";
import formValidation from "../mixins/form-validation";
import moment from 'moment-timezone'


@Component
export default class DateInput extends Mixins(form, formText, formValidation) {
  inheritAttrs: false;
  localValue: string;
  warning: string = "";

  $refs!: {
    input: HTMLInputElement;
  };

  @Prop({ default: true })
  editable: boolean;

  @Prop({ default: true })
  timeOnly: boolean;

  @Prop({ default: "MM/DD/YYYY" })
  format: string;

  @Prop({ default: "1111" })
  formatted: string;

  @Prop({ default: "2000-01-01" })
  min: string;

  @Prop({ default: false })
  highlight: boolean;

  @Prop({ default: false })
  invalid: boolean;

  toggleDatePicker(e) {
    let target = `${e}_ref`;
    this.$refs[target].$el.click();
  }

  get formattedValue() {
    if (!this.localValue) return "";
    return formatDate(this.localValue, !this.editable ? this.format : "YYYY-MM-DD");
  }

  set formattedValue(val) {
    this.localValue = val;
  }


  @Watch("value")
  valueChanged(val) {
    this.localValue = val;
  }

  checkDate() {
    var self = this;
    if (this.id == "scheduleDeliveryDate")
    {
      if (!this.dateInPast() && !this.dateInFuture())
      {
        self.warning = ""
      }
    }
  }

  dateInPast() {
    var self = this;
    if (moment(this.localValue).tz("America/Toronto").isBefore(moment(), 'day')) {
      self.warning =   "Delivery Date " + moment(this.localValue).format("MM-DD-YYYY") + " is in the past (" + moment().tz("America/Toronto").diff(this.localValue, 'days') + " days ago)"
      return true;
    } else {
      return false
    }
  }

  dateInFuture() {
    var self = this;
    if (moment(this.localValue).tz("America/Toronto").isSameOrAfter(moment({hours: 0}).tz("America/Toronto").add(180, 'd'))) {
      self.warning =  "Delivery Date " + moment(this.localValue).format("MM-DD-YYYY") + " is in the future (in " +  moment(this.localValue).tz("America/Toronto").diff(moment({hours: 0}).tz("America/Toronto"), 'days') + " days)"
      return true;
    } else {
      return false
    }
  }


  updateDate(obj) {
    if (obj === null) {
      this.$emit("input", null);
    } else if (obj.end) {
      this.$emit("input", `${obj.start} ~ ${obj.end}`);
    } else {
      this.$emit("input", obj);
    }
  }
}
